var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHIcInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1906 20.0531C17.1906 21.6051 18.4488 22.8632 20.0007 22.8632C21.5527 22.8632 22.8109 21.6051 22.8109 20.0531C22.8109 18.5011 21.5527 17.243 20.0007 17.243C18.4488 17.243 17.1906 18.5011 17.1906 20.0531Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7031 12.3565H24.2964C26.1742 12.3565 27.6964 13.8787 27.6964 15.7565V24.3498C27.6964 26.2276 26.1742 27.7498 24.2964 27.7498H15.7031C13.8254 27.7498 12.3031 26.2276 12.3031 24.3498V15.7565C12.3031 13.8787 13.8254 12.3565 15.7031 12.3565ZM20.0007 15.643C17.5651 15.643 15.5906 17.6175 15.5906 20.0531C15.5906 22.4888 17.5651 24.4632 20.0007 24.4632C22.4364 24.4632 24.4109 22.4888 24.4109 20.0531C24.4109 17.6175 22.4364 15.643 20.0007 15.643ZM25.0058 13.7981C24.396 13.7981 23.9016 14.2925 23.9016 14.9024C23.9016 15.5123 24.396 16.0067 25.0058 16.0067C25.6157 16.0067 26.1101 15.5123 26.1101 14.9024C26.1101 14.2925 25.6157 13.7981 25.0058 13.7981Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM10.7031 15.7565C10.7031 12.995 12.9417 10.7565 15.7031 10.7565H24.2964C27.0579 10.7565 29.2964 12.995 29.2964 15.7565V24.3498C29.2964 27.1112 27.0579 29.3498 24.2964 29.3498H15.7031C12.9417 29.3498 10.7031 27.1112 10.7031 24.3498V15.7565Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcInstagram);
export default __webpack_public_path__ + "static/media/h_ic_instagram.faaf86eb.svg";
export { ForwardRef as ReactComponent };